import { call, put, spawn, delay } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  add as addToast,
  set as setToast,
  remove as removeToast
} from 'store/redux/toasts'

function * delayedRemoveToast (taskId) {
  yield delay(10000)

  yield put(removeToast({
    id: `task-${taskId}`,
  }))
}

function * getTaskStatus ({
  taskId,
  progressMessage,
  completedMessage,
  failMessage,
}) {
  try {
    const Task = yield call(apiGetData, 'TaskStatus', { taskId })

    const { Status, Progress } = Task

    if (
      Status === 'Running' ||
      Status === 'Waiting'
    ) {
      let canceled = false

      yield put(setToast({
        id: `task-${taskId}`,
        message: progressMessage,
        progress: Progress.Progress * 100,
        onClose: () => {
          canceled = true
        }
      }))

      yield delay(2000)

      if (!canceled) {
        return yield getTaskStatus({
          taskId,
          progressMessage,
          completedMessage,
          failMessage,
        })
      }
    } else if (Status === 'Completed') {
      yield put(setToast({
        id: `task-${taskId}`,
        message: completedMessage,
        type: 'success',
        progress: 100
      }))

      yield spawn(delayedRemoveToast, taskId)

      return Task
    } else if (Status === 'Failed') {
      yield put(setToast({
        id: `task-${taskId}`,
        message: failMessage,
        type: 'danger',
        progress: false
      }))

      yield spawn(delayedRemoveToast, taskId)
    }
  } catch (error) {
    yield put(removeToast({
      id: `task-${taskId}`,
    }))

    if (error.code !== 401) {
      throw error
    }
  }
}

export default function * taskStatus ({
  taskId,
  progressMessage,
  completedMessage,
  failMessage,
}) {
  yield put(addToast({
    id: `task-${taskId}`,
    message: progressMessage,
    progress: 0,
    close: true,
  }))

  return yield getTaskStatus({
    taskId,
    progressMessage,
    completedMessage,
    failMessage,
  })
}
